/**
 * Axios Configuration - SIMPLIFIED
 */

import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || 'https://a2amyeditorai-server.appsokay.net/api/v1',
  timeout: 15000, // Reduced from 30s to 15s for faster failure
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor - just return data
axiosInstance.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // Log error but DON'T redirect - let components handle it
    console.error('[API Error]', error.response?.status, error.config?.url);
    console.error('[API Error] Full error:', error);
    console.error('[API Error] Response data:', error.response?.data);
    // Preserve the full error object so components can access response.data
    return Promise.reject(error);
  }
);

export default axiosInstance;
